var map = {
	"./blackGold/footer/Icon-gift.png": 92312,
	"./brownGold/footer/Icon-gift.png": 81657,
	"./darkBlue/footer/Icon-gift.png": 73097,
	"./greenYellow/footer/Icon-gift.png": 12615,
	"./redGold/footer/Icon-gift.png": 56,
	"./skyBlue/footer/Icon-gift.png": 33773,
	"./whiteGold/footer/Icon-gift.png": 31825,
	"./yellowWhite/footer/Icon-gift.png": 41676
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 27943;